import styled from '@emotion/styled';

export const AugmentedSearchWrapper = styled.div`
  margin-top: 40px;
`;
